import { render, staticRenderFns } from "./PanelModalData.vue?vue&type=template&id=79180605&scoped=true"
import script from "./PanelModalData.vue?vue&type=script&lang=js"
export * from "./PanelModalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79180605",
  null
  
)

export default component.exports